// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"4551df1c","242":"6f417ad2","494":"2db165ae","558":"99295ff4","586":"8b6d7056","588":"1be91ef1","841":"ee6a4725","879":"8ea7359f","903":"0c05b067"}[chunkId] + ".chunk.js";
};